import styled from 'styled-components';
import { Flex, FlexProps } from '../../../../layout/Flex';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'BusinessRegistrationAccountControl' })
    .attrs<FlexProps>({
        direction: 'row',
        p: 2,
        borderRadius: 2,
        spacing: 2,
        border: '1px solid var(--divider)',
        cursor: 'pointer',
        width: '100%',
    })``;
